import React from 'react';
import { Steps, Grid } from 'antd';
import { EnterpriseTokens } from '@/theme/enterprise-tokens';

export interface WorkflowStage {
  title: string;
  description?: string;
  status?: 'wait' | 'process' | 'finish' | 'error';
}

export interface WorkflowStripProps {
  stages: WorkflowStage[];
  current?: number;
  compact?: boolean;
}

/**
 * Read-only process visibility — props only, no business rules.
 */
export const WorkflowStrip: React.FC<WorkflowStripProps> = ({ stages, current = 0, compact }) => {
  const screens = Grid.useBreakpoint();
  if (!stages.length) return null;
  const padX = `clamp(${EnterpriseTokens.spacing.md}px, 3vw, ${EnterpriseTokens.workspace.headerPaddingX}px)`;
  /* MODERN UPGRADE: Vertical steps on narrow viewports for readability */
  const direction = screens.md ? 'horizontal' : 'vertical';
  return (
    <div
      style={{
        padding: `${compact ? EnterpriseTokens.spacing.sm : EnterpriseTokens.spacing.md}px ${padX}`,
        background: '#fff',
        borderBottom: EnterpriseTokens.workspace.borderSubtle,
      }}
    >
      <div style={{ overflowX: direction === 'horizontal' ? 'auto' : undefined, WebkitOverflowScrolling: 'touch' }}>
        <Steps
          direction={direction}
          size={compact ? 'small' : 'default'}
          current={current}
          items={stages.map((s) => ({
            title: s.title,
            description: s.description,
            status: s.status,
          }))}
        />
      </div>
    </div>
  );
};
